import React, { useState, useEffect } from 'react'
import { Grid, TextField } from '@material-ui/core'

import { Dialog } from 'components'
import { useApiCall } from 'hooks'

import { getUserPollResult } from '../../api'
import { User, UserPollResult } from '../../types'

interface PollDialogProps {
  data: User
  onCancel: () => void
}

const PollDialog = ({ ...props }: PollDialogProps) => {
  const { onCancel, data } = props

  const [pollResults, setPollResults] = useState<UserPollResult[] | undefined>(undefined)
  const [getUserPollResultApi] = useApiCall<number, UserPollResult[]>(getUserPollResult)

  useEffect(() => {
    if (!pollResults) {
      const fetchData = async () => {
        const userPollResult = await getUserPollResultApi(data.id)
        if (userPollResult) setPollResults(userPollResult)
      }
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.id, pollResults])

  return (
    <Dialog title="Green Test" isOpen showActions readOnly onCancel={onCancel}>
      <Grid container spacing={3}>
        {!pollResults || !pollResults.length
          ? 'No hay datos'
          : pollResults.map(item => (
              <Grid key={item.id} item xs={12}>
                {item.userPoll?.question}
                <TextField label={item.userPollDetail.answer} fullWidth disabled />
              </Grid>
            ))}
      </Grid>
    </Dialog>
  )
}

export { PollDialog }
